module.exports = __webpack_public_path__ + "media/brands/deutz-59587df7.png";